import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { aiAgentColors } from 'constants/aiAgentColors';

export const StyledLeadScoringAgent = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid transparent;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(90deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%) border-box;
`;

export const StyledLeadScoringAgentHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLeadScoringAgentContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

export const StyledLeadScoringAgentHeaderText = styled.div`
  ${setFontVariant('report', colorsPalettes.carbon[400])}
`;

export const StyledLeadScoringButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
